module.exports = __webpack_public_path__ + "static/img/zhanhui-3.af77818c.png";